import { render, staticRenderFns } from "./BeCalmCourse.vue?vue&type=template&id=66fee6da&"
import script from "./BeCalmCourse.vue?vue&type=script&lang=js&"
export * from "./BeCalmCourse.vue?vue&type=script&lang=js&"
import style0 from "./BeCalmCourse.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports